<div
  class="driver-status-card"
  [id]="getVehicleIdSelector(driverStatus.vehicleTachoInfo.status.VehicleId)"
  (mouseenter)="onDriverMouseEnter()"
  (mouseleave)="onDriverMouseLeave()"
  (contextmenu)="onStatusCardRightClick($event)"
  (click)="onDriverCardClick()"
>
  <div class="driver-status-card__header">
    <div class="driver-status-card__header__title">
      <mat-icon [svgIcon]="'ic-' + driverStatus.icon" class="driver-status-card__header-icon mat-icon-size-xs"></mat-icon>
      <div class="driver-status-card__driver-name">
        <span
          i18n="@@S_NODRIVER"
          *ngIf="driverStatus.driverName !== null && (driverStatus.driverName.trim() === ',' || driverStatus.driverName.trim() === '')"
        >
          No driver
        </span>
        <span *ngIf="driverStatus.driverName !== null && driverStatus.driverName.trim() !== ','">{{ driverStatus.driverName }}</span>
        <span
          *ngIf="driverStatus.driverName === null"
          i18n-fmTooltip="@@S_TACHO_UNASSIGNED_DRIVER_TIP"
          fmTooltip="This vehicle has no driver assigned"
          i18n="@@S_TACHO_UNASSIGNED_DRIVER"
          >Unassigned driver</span
        >
      </div>
      <div class="driver-status-card__vehicle-name">
        {{ driverStatus.vehicleName }}
      </div>
    </div>
    <mat-icon
      class="driver-status-card__menu-icon mat-icon-size-xs"
      svgIcon="ds-ic-elipsis"
      (click)="onStatusCardMenuIconClick($event)"
      a7s-id="live-map-selection-panel-driver-list-contextual-menu"
    ></mat-icon>
  </div>
  <div class="driver-status-card__body">
    <div class="driver-status-card__status">
      <lib-tacho-message-section [tacho]="driverStatus.vehicleTachoInfo.status"></lib-tacho-message-section>
    </div>
  </div>
</div>
